import { Component, Input, OnInit } from "@angular/core";

export interface CardElement {
  logo: string;
  title: string;
  subtitle: string;
  time: string;
  mainText: string;
}

@Component({
    selector: "app-shared-card-grid",
    templateUrl: "./shared-card-grid.component.html",
    styleUrls: ["./shared-card-grid.component.css"],
    standalone: false
})
export class SharedCardGridComponent {
  @Input()
  cards: CardElement[];

  @Input()
  columns: number;

  @Input()
  circularLogos = true;

  constructor() {}
}
